// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   border-bottom: var(--border);
   background-color: var(--header-bg);
   align-items: center;
   height: 60px;
   width: 100%;
   z-index: 5;
}

.main-header .logo-button {
   background-color: unset;
   padding: unset;
   transition: unset;
   height: unset;
}

.main-header .logo-button:hover {
   background-color: unset;
}

.main-header .logo-img {
   height: 60px;
}

.drop-down-container .main-menu{
   display: flex;
   flex-direction: column;
}

.drop-down-container .main-menu > button{
   background-color: unset;
   border-radius: unset;
   text-align: left;
   color: var(--color)
}

.drop-down-container .main-menu > button,
.drop-down-container .main-menu #theme-toggle,
.drop-down-container .main-menu #wide-view-switch-container
 {
   padding: var(--padding-sm) var(--padding);
   margin: unset;
   height: 30px;
   cursor: pointer;
}

.drop-down-container .main-menu #theme-toggle:hover,
.drop-down-container .main-menu #wide-view-switch-container:hover{
   background-color: var(--button-primary-hovered);
}

.main-header .app-store-button {
   width: 300px;
}

#wide-view-switch-container,
#theme-toggle {
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   width: 100%;
}

#wide-view-switch-container p,
#theme-toggle p {
   padding: var(--padding-sm) 0;
}

@media only screen and (max-width: 800px) {

   /* 800px is coming from the width restraint we're putting on content in narrow-view
   when the screen gets more narrow than 800px, we don't need the "Wide View" switch in the menu
   */
   #wide-view-switch-container {
      display: none;
   }

   /* Matches buttons a bit better when in full screen dropdown*/
   .dropdown-content #theme-toggle {
      margin: 5px;
   }
}

/* When dropdown goes to full screen (769px) make theme toggle a bit taller.  Definite refactor candidate here*/
@media (max-width: 769px) and (orientation: portrait), 
(max-height: 769px) and (orientation: landscape) {
   #theme-toggle {
      height: 40px;
      min-height: 40px;
   }
}`, "",{"version":3,"sources":["webpack://./src/pages/components/MainHeader/MainHeader.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,4BAA4B;GAC5B,kCAAkC;GAClC,mBAAmB;GACnB,YAAY;GACZ,WAAW;GACX,UAAU;AACb;;AAEA;GACG,uBAAuB;GACvB,cAAc;GACd,iBAAiB;GACjB,aAAa;AAChB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,uBAAuB;GACvB,oBAAoB;GACpB,gBAAgB;GAChB;AACH;;AAEA;;;;GAIG,yCAAyC;GACzC,aAAa;GACb,YAAY;GACZ,eAAe;AAClB;;AAEA;;GAEG,+CAA+C;AAClD;;AAEA;GACG,YAAY;AACf;;AAEA;;GAEG,aAAa;GACb,mBAAmB;GACnB,mBAAmB;GACnB,8BAA8B;GAC9B,WAAW;AACd;;AAEA;;GAEG,4BAA4B;AAC/B;;AAEA;;GAEG;;IAEC;GACD;MACG,aAAa;GAChB;;GAEA,6DAA6D;GAC7D;MACG,WAAW;GACd;AACH;;AAEA,+GAA+G;AAC/G;;GAEG;MACG,YAAY;MACZ,gBAAgB;GACnB;AACH","sourcesContent":[".main-header {\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: space-between;\r\n   border-bottom: var(--border);\r\n   background-color: var(--header-bg);\r\n   align-items: center;\r\n   height: 60px;\r\n   width: 100%;\r\n   z-index: 5;\r\n}\r\n\r\n.main-header .logo-button {\r\n   background-color: unset;\r\n   padding: unset;\r\n   transition: unset;\r\n   height: unset;\r\n}\r\n\r\n.main-header .logo-button:hover {\r\n   background-color: unset;\r\n}\r\n\r\n.main-header .logo-img {\r\n   height: 60px;\r\n}\r\n\r\n.drop-down-container .main-menu{\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.drop-down-container .main-menu > button{\r\n   background-color: unset;\r\n   border-radius: unset;\r\n   text-align: left;\r\n   color: var(--color)\r\n}\r\n\r\n.drop-down-container .main-menu > button,\r\n.drop-down-container .main-menu #theme-toggle,\r\n.drop-down-container .main-menu #wide-view-switch-container\r\n {\r\n   padding: var(--padding-sm) var(--padding);\r\n   margin: unset;\r\n   height: 30px;\r\n   cursor: pointer;\r\n}\r\n\r\n.drop-down-container .main-menu #theme-toggle:hover,\r\n.drop-down-container .main-menu #wide-view-switch-container:hover{\r\n   background-color: var(--button-primary-hovered);\r\n}\r\n\r\n.main-header .app-store-button {\r\n   width: 300px;\r\n}\r\n\r\n#wide-view-switch-container,\r\n#theme-toggle {\r\n   display: flex;\r\n   flex-direction: row;\r\n   align-items: center;\r\n   justify-content: space-between;\r\n   width: 100%;\r\n}\r\n\r\n#wide-view-switch-container p,\r\n#theme-toggle p {\r\n   padding: var(--padding-sm) 0;\r\n}\r\n\r\n@media only screen and (max-width: 800px) {\r\n\r\n   /* 800px is coming from the width restraint we're putting on content in narrow-view\r\n   when the screen gets more narrow than 800px, we don't need the \"Wide View\" switch in the menu\r\n   */\r\n   #wide-view-switch-container {\r\n      display: none;\r\n   }\r\n\r\n   /* Matches buttons a bit better when in full screen dropdown*/\r\n   .dropdown-content #theme-toggle {\r\n      margin: 5px;\r\n   }\r\n}\r\n\r\n/* When dropdown goes to full screen (769px) make theme toggle a bit taller.  Definite refactor candidate here*/\r\n@media (max-width: 769px) and (orientation: portrait), \r\n(max-height: 769px) and (orientation: landscape) {\r\n   #theme-toggle {\r\n      height: 40px;\r\n      min-height: 40px;\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
